exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".skittle {\n  position: absolute;\n  cursor: pointer;\n  border: 1px solid #ccc; }\n\n.skittle-tooltip {\n  display: inline-block; }\n\n.skittle-tooltipText {\n  visibility: hidden;\n  width: auto;\n  background-color: black;\n  font-size: 12px;\n  font-weight: 600;\n  color: #fff;\n  text-align: center;\n  padding: 5px 3px;\n  margin: 15px 0px 0px 10px;\n  /* Position the tooltip */\n  position: absolute;\n  z-index: 1; }\n\n.skittle-tooltip:hover .skittle-tooltipText {\n  visibility: visible; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/d3Components/skittlesChart/skittle.scss
// module id = 900
// module chunks = 0